import { render, staticRenderFns } from "./reel_detail.vue?vue&type=template&id=6e55937d&"
import script from "./reel_detail.vue?vue&type=script&lang=js&"
export * from "./reel_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports